





















import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'ChartClassRank',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '' }) private tips!: string
  @Prop({ default: '#00B66C' }) private color!: string
  @Prop({ default: '580px' }) private innerChartHeight!: string
  @Prop({ required: true }) private list!: Array<any>
  // 参考标准线
  @Prop({ required: true }) private lineMark!: number
  private chartId: string = ''
  private yData: Array<string> = []
  private xData: Array<any> = []
  private markData: Array<any> = []
  // private lineData: Array<any> = []
  private option: any = {
    animation: false,
    grid: {
      left: '50',
      show: false
      // containLabel: true
    },
    xAxis: {
      position: 'top',

      axisLine: {
        show: false
      },

      axisTick: {
        show: false
      },
      name: '均分',
      max: 100
    },
    yAxis: {
      data: [],
      nameTextStyle: {
        fontSize: 10
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: [
      // {
      //   type: 'line',
      //   name: '参考标准',
      //   data: [],
      //   itemStyle: {
      //     color: '#CBCBCB'
      //   }
      // },
      {
        type: 'bar',
        name: '均值',
        data: [],
        // data: this.xData,
        itemStyle: {
          color: '#00B66C',
          borderRadius: 5
        },
        barWidth: 10,
        markLine: {
          itemStyle: {
            color: '#666'
          },
          label: {
            show: false,
            position: 'start'
          },
          symbol: ['none', 'none'],
          lineStyle: {
            width: 2
          },
          data: [
            {
              name: '0',
              xAxis: this.lineMark
            }
          ]
        }
      },
      {
        type: 'custom',
        name: '标准差',
        renderItem: this.renderItem,
        encode: {
          x: 0,
          y: [1, 2]
        },
        itemStyle: {
          color: '#FFA100'
        },
        data: [],
        z: 100
      }
    ]
  }
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')

    this.xData = []
    this.yData = []
    this.markData = []
    let barList = JSON.parse(JSON.stringify(this.list))
    barList.reverse().map((item: any, index: number) => {
      // this.yData.push(item.classroomName.substring(0, 3))
      this.yData.push(item.classroomName)
      let mean = item.mean || 0
      let standardDeviation = item.standardDeviation || 0
      this.xData.push(mean || 0)
      this.markData.push([index, mean - standardDeviation / 2, mean + standardDeviation / 2])
      // this.lineData.push(this.lineMark)
    })
    console.log(this.xData)
    console.log(this.yData)
    console.log(this.markData)
    this.option.yAxis.data = this.yData
    // x轴数据
    this.option.series[0].data = this.xData
    this.option.series[0].markLine.data[0].xAxis = this.lineMark
    //
    this.option.series[1].data = this.markData
  }
  mounted() {
    this.setOption()
  }

  private renderItem(params:any, api:any) {
    var yIndex = api.value(0)
    var start = api.coord([api.value(1), yIndex])
    var end = api.coord([api.value(2), yIndex])
    // var height = api.size([0, 1])[1] * 0.6;
    // var highPoint = api.coord([yIndex, api.value(1)]);
    // var lowPoint = api.coord([yIndex, api.value(2)]);
    var halfWidth = api.size([1, 0])[0] * 1
    var style = api.style({
      stroke: api.visual('color'),
      fill: null
    })

    return {
      type: 'group',
      children: [{
        type: 'line',
        transition: ['shape'],
        shape: {
          x1: start[0],
          y1: start[1] - halfWidth * 2,
          x2: start[0],
          y2: start[1] + halfWidth * 2
        },
        style: style
      }, {
        type: 'line',
        transition: ['shape'],
        shape: {
          x1: start[0],
          y1: start[1] - halfWidth * 2,
          x2: end[0],
          y2: end[1] - halfWidth * 2
        },
        style: style
      }, {
        type: 'line',
        transition: ['shape'],
        shape: {
          x1: start[0],
          y1: start[1] + halfWidth * 2,
          x2: end[0],
          y2: end[1] + halfWidth * 2
        },
        style: style
      }, {
        type: 'line',
        transition: ['shape'],
        shape: {
          x1: end[0],
          y1: end[1] - halfWidth * 2,
          x2: end[0],
          y2: end[1] + halfWidth * 2
        },
        style: style
      }]
    }
  }

  private setOption() {
    let eChart = this.$refs.chart as any
    // this.option.xAxis[0].data = data.xAxis
    // this.option.xAxis[1].data = data.xAxis
    // this.option.series[0].data = data.yAxisBenchmark
    // this.option.series[1].data = data.yAxis
    // this.option.series[1].markPoint.data = []
    eChart.setOption(this.option)
  }
}
